import SignUp from './SignUp';

export default SignUp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/SignUp/index.ts